module.exports = __webpack_public_path__ + "static/media/rodologo.691fdc4c.png";